import styled from "styled-components";

import {
  DefaultParagraphLargeFactory,
  DefaultParagraphSmallFactory,
  DefaultTitleXLargeFactory,
} from "../../../../components/Habitacional/core/Typograph/Typograph.Style";

export const ChooseProductContainer = styled.section(({ theme }) => ({
  paddingTop: "40px",
  paddingBottom: "40px",
  marginBottom: "0 !important",

  [theme.breakpoint.lg()]: {
    paddingTop: "60px",
    paddingBottom: "60px",
    gap: "40px",
  },
}));

export const ChooseProductContent = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "32px",

  [theme.breakpoint.lg()]: {
    gap: "60px",
  },
}));

export const ChooseProductTitle = styled.h2(({ theme }) => ({
  ...DefaultTitleXLargeFactory({ theme }),
}));

export const ChooseProductList = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px",

  [theme.breakpoint.lg()]: {
    flexDirection: "row",

    ".tab-item + .tab-item": {
      borderLeft: `1px solid ${theme.color.line.medium}`,
      paddingLeft: "32px",
    },
  },
}));

export const ChooseProductItem = styled.div(() => ({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  gap: "32px",
  paddingRight: "32px",
}));

export const ChooseProductItemHeader = styled.header(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
}));

export const ChooseProductItemLink = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "8px",

  button: {
    ...DefaultParagraphLargeFactory({ theme }),
    fontWeight: 600,
    gap: "16px",
  },
}));

export const ChooseProductItemLinkDescription = styled.p(({ theme }) => ({
  fontWeight: 400,
  lineHeight: "150%",

  strong: {
    ...DefaultParagraphSmallFactory({ theme }),
    fontWeight: 700,
  },
}));
